<template>
  <v-layout>
    <v-col v-if="Topic.isForm" cols :sm="12" class="pa-0">
      <v-form v-model="Topic.isValid" ref="form">
        <v-card flat class="pt-5">
          <v-layout align-center class="px-3">
            <h2>{{ $t("menu.topic") }}</h2>
            <v-spacer></v-spacer>
            <v-icon @click="_fnReset()" color="primary"> mdi-close </v-icon>
          </v-layout>
          <v-card-text>
            <v-row>
              <v-col cols :sm="6" class="py-0">
                <v-upload
                  :width="450"
                  :height="250"
                  class="mb-3"
                  :label="$t(`table.image`)"
                  v-model="Topic.obj.image"
                  :rules="[Rules.required]"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols :sm="6" class="py-0">
                <v-text-field
                  color="primary"
                  :rules="[Rules.required]"
                  v-model="Topic.obj.nameVI"
                >
                  <template #label>
                    {{ $t(`table.name`) + " (VI)" }}
                    <span class="red--text">
                      <strong>*</strong>
                    </span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols :sm="6" class="py-0">
                <v-text-field
                  color="primary"
                  :rules="[Rules.required]"
                  v-model="Topic.obj.nameEN"
                >
                  <template #label>
                    {{ $t(`table.name`) + " (EN)" }}
                    <span class="red--text">
                      <strong>*</strong>
                    </span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols :sm="6" class="py-0">
                <v-text-field color="primary" v-model="Topic.obj.userAllow">
                  <template #label>
                    {{ $t(`table.userAllow`) }}
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols :sm="6" class="py-0">
                <v-typeTopic
                  v-model="Topic.obj.types"
                  :rules="[Rules.required]"
                  multiple
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols :sm="6" class="py-0">
                <v-text-field
                  color="primary"
                  type="number"
                  :rules="[Rules.required, Rules.number]"
                  v-model="Topic.obj.priority"
                >
                  <template #label>
                    {{ $t(`table.priority`) }}
                    <span class="red--text">
                      <strong>*</strong>
                    </span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols :sm="6" class="py-0">
                <v-statusTopic
                  v-model="Topic.obj.status"
                  :rules="[Rules.required]"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="px-4">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :disabled="!Topic.isValid"
              @click="Topic.isCreate ? _fnCreate() : _fnUpdate()"
              >{{ Topic.isCreate ? $t(`table.create`) : $t(`table.update`) }}
            </v-btn>
            <v-btn outlined color="primary" @click="_fnReset()">
              {{ $t(`table.cancel`) }}
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-col>

    <v-dialog
      v-if="Topic.isDelete"
      v-model="Topic.isDelete"
      persistent
      scrollable
      max-width="500"
    >
      <v-card>
        <v-card-title dense class="headline primary" />
        <v-card-text class="pt-2">
          {{ $t(`table.deleteMess`) }}
          <b>{{ Topic.obj.title }}</b>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="_fnDelete()">
            {{ $t(`table.delete`) }}
          </v-btn>
          <v-btn outlined color="primary" @click="_fnReset()">
            {{ $t(`table.cancel`) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  data: () => ({
    model: "Topic",
  }),
  methods: {
    _fnReset() {
      if (this.$refs.form) this.$refs.form.reset();
      this.fnResetFlagView(this.model);
    },
    _fnReFresh() {
      this._fnReset();
      this[this.model].isRefresh = true;
    },
    async _fnCreate() {
      if (!this[this.model].obj.userAllow) {
        this[this.model].obj.userAllow = null;
      }
      const { code } = await this.fnPost({
        url: `/v1/admin/topic`,
        model: this.model,
      });
      if (code === 200) {
        this._fnReFresh();
      }
    },
    async _fnUpdate() {
      if (!this[this.model].obj.userAllow) {
        this[this.model].obj.userAllow = null;
      }
      const { code } = await this.fnPut({
        url: `/v1/admin/topic/${this[this.model].obj.id}`,
        model: this.model,
      });
      if (code === 200) {
        this._fnReFresh();
      }
    },
    async _fnDelete() {
      const { code } = await this.fnDelete({
        url: `/v1/admin/topic/${this[this.model].obj.id}`,
        model: this.model,
      });
      if (code === 200) {
        this._fnReFresh();
      }
    },
  },
};
</script>
